module.exports = __webpack_public_path__ + "img/smalldot1.2139432a.png";